import React, { useContext, useEffect, useState } from 'react';
import { nosotrosMainBanner, nosotrosMainBannerEn } from '../../json/nosotros/mainBanner';
import MainBanner from './MainBanner/MainBanner';
import { LanguageContext } from '../../context/LanguageContext/LanguageContext';
import Acerca from './Acerca/Acerca';
import Titles from './Titles/Titles';
import GeneralServices from '../Services/GeneralServices/GeneralServices';
import { images } from '../../json/nosotros/imagenes';
import ImageGrid from './ImageGrid/ImageGrid';
import SpecializedTeam from './SpecializedTeam/SpecializedTeam';
import { generalServices, generalServicesEn } from '../../json/generalServices';

const Nosotros = () => {
    const { language } = useContext(LanguageContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const data = language === 'ES'
        ? nosotrosMainBanner[0]
        : nosotrosMainBannerEn[0];

    const services = language === 'ES' ? generalServices : generalServicesEn;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const combinedData = [];
    const maxLength = Math.max(services.length, images.length);
    for (let i = 0; i < maxLength; i++) {
        if (services[i]) combinedData.push({ type: 'service', data: services[i] });
        if (images[i]) combinedData.push({ type: 'image', data: images[i] });
    }

    return (
        <>
            <MainBanner {...data} />
            <Acerca />
            <Titles />
            {isMobile ? (
                <div className="container services-container">
                    {combinedData.map((item, index) => {

                        return (
                            <div>
                                {item.type === 'service' ? (
                                    <div className={`service-card ${index % 4 === 0 ? 'black-bg' : 'yellow-bg'}`}>
                                        <h3 dangerouslySetInnerHTML={{ __html: item.data.title }}></h3>
                                        <p>{item.data.description}</p>
                                        <div className='content-arrow-link'>
                                            <a href={item.data.link} className="arrow-link">
                                                <span>➔</span>
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="image-grid-container">
                                        <img
                                            src={item.data.src}
                                            alt={item.data.alt || `Image ${index + 1}`}
                                            style={{ width: "100%", height: "auto", borderRadius: "8px" }}
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <>
                    <GeneralServices />
                    <ImageGrid images={images} />
                </>
            )}
            <SpecializedTeam />
        </>
    );
};

export default Nosotros;
